import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const UpgradePrompt = ({ feature = "this feature", requiredTier = "Wealth Builder", compact = false }) => {
  const navigate = useNavigate();

  if (compact) {
    return (
      <Card className="border-dashed border-2 border-emerald-200 bg-emerald-50/30" data-testid="upgrade-prompt-compact">
        <CardContent className="py-4">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 min-w-0">
              <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-emerald-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-stone-800">{feature} requires {requiredTier}</p>
                <p className="text-xs text-stone-500">Upgrade your plan to unlock</p>
              </div>
            </div>
            <Button
              size="sm"
              className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs rounded-full flex-shrink-0"
              onClick={() => navigate("/subscription")}
              data-testid="upgrade-btn-compact"
            >
              Upgrade
            </Button>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-[400px]" data-testid="upgrade-prompt-full">
      <Card className="max-w-md w-full border-2 border-emerald-200 overflow-hidden">
        <div className="h-2 bg-gradient-to-r from-emerald-500 via-emerald-400 to-[#1e3a5f]" />
        <CardContent className="py-12 text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-emerald-100 flex items-center justify-center">
            <svg className="w-8 h-8 text-emerald-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
          </div>
          <Badge className="bg-emerald-100 text-emerald-800 border-0 mb-4">{requiredTier} Plan</Badge>
          <h2 className="text-xl font-bold text-stone-900 mb-2">Unlock {feature}</h2>
          <p className="text-stone-500 text-sm mb-6 max-w-sm mx-auto">
            Upgrade to the {requiredTier} plan ($249/mo) to access {feature}, plus all Enterprise features.
          </p>
          <div className="space-y-3">
            <Button
              className="w-full bg-emerald-600 hover:bg-emerald-700 text-white rounded-full py-5"
              onClick={() => navigate("/subscription")}
              data-testid="upgrade-btn-full"
            >
              Upgrade to {requiredTier}
            </Button>
            <Button
              variant="ghost"
              className="w-full text-stone-500 text-sm"
              onClick={() => navigate("/dashboard")}
            >
              Back to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default UpgradePrompt;
